<template>
  <div class="section no-pad-bot landing_dark" id="index-banner">
    <br />
    <br />
    <div class="row">
      <div class="col l5 s12">
        <router-link to="/">
          <h1 class="header center white-text text-darken-3">Supersquares</h1>
        </router-link>
        <div class="row">
          <div class="col s12">
            <h5 class="header-lite center white-text">Throw the paper away</h5>
          </div>
        </div>
        <div class="row center">
          <a class="btn-large waves-effect waves-light green" @click="registerModal">Get on the list</a>
        </div>
      </div>
      <div class="col l7 s12">
        <FrontGrid />
      </div>
    </div>
    <RegistrationModal />
  </div>
</template>

<script>
import RegistrationModal from './RegistrationModal.vue'
import FrontGrid from '@/components/FrontGrid.vue'
import M from 'materialize-css'

export default {
  components: {
    RegistrationModal,
    FrontGrid
  },
  methods: {
    registerModal () {
      let el = document.querySelector('#register')
      let modalInstance = M.Modal.getInstance(el)
      modalInstance.open()
    }
  }
}
</script>

<style>
</style>
